import { cn, tv, VariantProps } from "@utils/tw"
import { ComponentPropsWithoutRef, ReactElement } from "react"

type Props = ComponentPropsWithoutRef<"button"> &
  VariantProps<typeof buttonStyles> & {
    icon?: ReactElement | null
    iconAlign?: "left" | "right"
  }

export function Button(props: Props) {
  const styles = buttonStyles(props)
  const { iconAlign = "right", ...restProps } = props
  const iconAlignVal = iconAlign ?? "right"

  return (
    <button {...restProps} className={cn(styles.base(), props.className)}>
      {props.icon && iconAlignVal === "left" && <span className={styles.icon()}>{props.icon}</span>}
      <span className={styles.label()}>{props.children}</span>
      {props.icon && iconAlignVal === "right" && <span className={styles.icon()}>{props.icon}</span>}
    </button>
  )
}

export const buttonStyles = tv({
  base: [
    "inline-flex items-center type-label-l justify-center outline-none cursor-pointer",
    "transition-colors active:transition-none",
    "rounded-sm h-8 px-5 gap-3",
  ],
  slots: {
    label: "pt-[0.1em]",
    icon: "",
  },
  variants: {
    variant: {
      primary: "bg-white/20 hover:bg-white/25 active:bg-white/30",
      outline: "border border-white/20 bg-transparent hover:border-white/25 active:bg-white/10",
      ghost: "bg-transparent hover:bg-white/15 active:bg-white/20",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
})
